import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Navbar } from '../src/Navbar';
import { HeroSlider } from '../src/HeroSlider';
import { FeaturesSection } from '../src/FeaturesSection';
import { Footer } from '../src/Footer';
import { SupportPage } from '../src/pages/SupportPage';
import { AboutPage } from '../src/pages/AboutPage';

const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView({ block: 'start', behavior: 'auto' });
        return;
      }
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
};

const HomePage: React.FC = () => {
  return (
    <div>
      <HeroSlider />
      <FeaturesSection />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <div className="min-h-screen bg-brand-black text-white font-sans selection:bg-brand-gold selection:text-black">
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/legal" element={<Navigate to="/support" replace />} />
            <Route path="/compliance" element={<Navigate to="/support" replace />} />
            <Route path="/privacy" element={<Navigate to="/support" replace />} />
            <Route path="/warranty" element={<Navigate to="/support" replace />} />
            <Route path="/contact" element={<Navigate to="/support" replace />} />
            <Route path="/downloads" element={<Navigate to="/support" replace />} />
            <Route path="/faq" element={<Navigate to="/support" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
